module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.model.general_setting) ? _c('div', [_c('h4', {
    staticClass: "group__headline"
  }, [_vm._v("Settings")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Failed products import email"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.model.general_setting.failed_import_notifier),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "failed_import_notifier", $$v)
      },
      expression: "model.general_setting.failed_import_notifier"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Domain"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.model.general_setting.domain),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "domain", $$v)
      },
      expression: "model.general_setting.domain"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Main email"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.model.general_setting.email),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "email", $$v)
      },
      expression: "model.general_setting.email"
    }
  }), _vm._v(" "), _vm._l((_vm.modelOrigin), function(data, index) {
    return [(
      data.setting_key === 'email' &&
      _vm.origins.length &&
      _vm.isValidOrigin(data.origin_id)
    ) ? _c('div', {
      staticClass: "mt-4 p-4 border rounded border-gray-500 border-solid w-1/2 ml-auto"
    }, [_c('div', {
      staticClass: "flex"
    }, [_c('div', {
      staticClass: "grow-0 shrink-0 basis-32"
    }, [_vm._v("\n                        Setting for " + _vm._s(_vm.getOriginName(data.origin_id)) + "\n                    ")]), _vm._v(" "), _c('el-input', {
      model: {
        value: (_vm.modelOrigin[index].setting),
        callback: function($$v) {
          _vm.$set(_vm.modelOrigin[index], "setting", $$v)
        },
        expression: "modelOrigin[index].setting"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "flex justify-end mt-4"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.onSubmitOriginSetting(
            data.id,
            _vm.modelOrigin[index].setting
          )
        }
      }
    }, [_vm._v("Save setting for\n                        " + _vm._s(_vm.getOriginName(data.origin_id)))])], 1)]) : _vm._e()]
  })], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Contact email"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.model.general_setting.contact_email),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "contact_email", $$v)
      },
      expression: "model.general_setting.contact_email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "BCC email"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.model.general_setting.bcc_email),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "bcc_email", $$v)
      },
      expression: "model.general_setting.bcc_email"
    }
  }), _vm._v(" "), _vm._l((_vm.modelOrigin), function(data, index) {
    return [(
      data.setting_key === 'bcc_email' &&
      _vm.origins.length &&
      _vm.isValidOrigin(data.origin_id)
    ) ? _c('div', {
      staticClass: "mt-4 p-4 border rounded border-gray-500 border-solid w-1/2 ml-auto"
    }, [_c('div', {
      staticClass: "flex"
    }, [_c('div', {
      staticClass: "grow-0 shrink-0 basis-32"
    }, [_vm._v("\n                        Setting for " + _vm._s(_vm.getOriginName(data.origin_id)) + "\n                    ")]), _vm._v(" "), _c('el-input', {
      model: {
        value: (_vm.modelOrigin[index].setting),
        callback: function($$v) {
          _vm.$set(_vm.modelOrigin[index], "setting", $$v)
        },
        expression: "modelOrigin[index].setting"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "flex justify-end mt-4"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.onSubmitOriginSetting(
            data.id,
            _vm.modelOrigin[index].setting
          )
        }
      }
    }, [_vm._v("Save setting for\n                        " + _vm._s(_vm.getOriginName(data.origin_id)))])], 1)]) : _vm._e()]
  })], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Stock alert email"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.model.general_setting.stock_alert_emails),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "stock_alert_emails", $$v)
      },
      expression: "model.general_setting.stock_alert_emails"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Stock alert trigger"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.model.general_setting.stock_alert_email_trigger),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "stock_alert_email_trigger", $$v)
      },
      expression: "model.general_setting.stock_alert_email_trigger"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Activate new customers"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.model.general_setting.new_customer_status),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "new_customer_status", $$v)
      },
      expression: "model.general_setting.new_customer_status"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.model.general_setting.new_customer_status),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "new_customer_status", $$v)
      },
      expression: "model.general_setting.new_customer_status"
    }
  }, [_vm._v("No")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Logo URL"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.model.general_setting.site_logo),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "site_logo", $$v)
      },
      expression: "model.general_setting.site_logo"
    }
  }), _vm._v(" "), _vm._l((_vm.modelOrigin), function(data, index) {
    return [(
      data.setting_key === 'site_logo' &&
      _vm.origins.length &&
      _vm.isValidOrigin(data.origin_id)
    ) ? _c('div', {
      staticClass: "mt-4 p-4 border rounded border-gray-500 border-solid w-1/2 ml-auto"
    }, [_c('div', {
      staticClass: "flex"
    }, [_c('div', {
      staticClass: "grow-0 shrink-0 basis-32"
    }, [_vm._v("\n                        Setting for " + _vm._s(_vm.getOriginName(data.origin_id)) + "\n                    ")]), _vm._v(" "), _c('el-input', {
      model: {
        value: (_vm.modelOrigin[index].setting),
        callback: function($$v) {
          _vm.$set(_vm.modelOrigin[index], "setting", $$v)
        },
        expression: "modelOrigin[index].setting"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "flex justify-end mt-4"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.onSubmitOriginSetting(
            data.id,
            _vm.modelOrigin[index].setting
          )
        }
      }
    }, [_vm._v("Save setting for\n                        " + _vm._s(_vm.getOriginName(data.origin_id)))])], 1)]) : _vm._e()]
  })], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Company name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.model.general_setting.company_name),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "company_name", $$v)
      },
      expression: "model.general_setting.company_name"
    }
  }), _vm._v(" "), _vm._l((_vm.modelOrigin), function(data, index) {
    return [(
      data.setting_key === 'company_name' &&
      _vm.origins.length &&
      _vm.isValidOrigin(data.origin_id)
    ) ? _c('div', {
      staticClass: "mt-4 p-4 border rounded border-gray-500 border-solid w-1/2 ml-auto"
    }, [_c('div', {
      staticClass: "flex"
    }, [_c('div', {
      staticClass: "grow-0 shrink-0 basis-32"
    }, [_vm._v("\n                        Setting for " + _vm._s(_vm.getOriginName(data.origin_id)) + "\n                    ")]), _vm._v(" "), _c('el-input', {
      model: {
        value: (_vm.modelOrigin[index].setting),
        callback: function($$v) {
          _vm.$set(_vm.modelOrigin[index], "setting", $$v)
        },
        expression: "modelOrigin[index].setting"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "flex justify-end mt-4"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.onSubmitOriginSetting(
            data.id,
            _vm.modelOrigin[index].setting
          )
        }
      }
    }, [_vm._v("Save setting for\n                        " + _vm._s(_vm.getOriginName(data.origin_id)))])], 1)]) : _vm._e()]
  })], 2)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-846fbef6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/General.vue
// module id = 549
// module chunks = 1